export default "__VITE_ASSET__e2f9709a__"